<template>
  <div class="chat-history-container">
    <!-- 聊天记录区域 -->
    <div class="chat-messages" ref="messagesContainer">
      <!-- 按日期分组显示消息 -->
      <div v-for="(group, date) in groupedMessages" :key="date" class="message-group">
        <!-- 日期分隔线 -->
        <!-- <div class="date-divider">
          <span>{{ formatDate(date) }}</span>
        </div> -->

        <!-- 单日内的所有消息 -->
        <div
          v-for="(message, index) in group"
          :key="index"
          class="message"
          :class="{
            'message-sent': message.sender === 'me',
            'message-received': message.sender !== 'me',
          }"
        >
          <!-- 对方消息显示头像 -->
          <div class="avatar" v-if="message.sender !== 'me'">
            <img :src="message.avatar" v-if="message.avatar" />
            <img src="@/assets/img/touxiang03.png" v-else />
          </div>
          <div class="message-content">
            <!-- 显示发送者名称（仅对方消息） -->
            <div class="sender-name flex-start" v-if="message.sender !== 'me'">
              <div style="margin-right: 5px">{{ message.senderName || "对方" }}</div>
              <!-- 消息时间 -->
              <div class="message-time">{{ formatTime(message.timestamp) }}</div>
            </div>

            <div class="sender-name flex-end" v-if="message.sender === 'me'">
              <!-- 消息时间 -->
              <div class="message-time">{{ formatTime(message.timestamp) }}</div>
              <div style="margin-left: 5px">{{ message.senderName || "我" }}</div>
            </div>
            <!-- 消息气泡 -->
            <div class="message-bubble">
              <div v-html="message.content.text"></div>
            </div>

            <!-- 消息时间 -->
            <!-- <div class="message-time">
              {{ formatTime(message.timestamp) }}
            </div> -->
          </div>
          <div class="avatar" style="margin-right: 0; margin-left: 5px" v-if="message.sender == 'me'">
            <img :src="message.avatar" v-if="message.avatar" />
            <img src="@/assets/img/touxiang03.png" v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Document } from "element-ui";
export default {
  components: { Document },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultAvatar: "https://example.com/default-avatar.jpg",
    };
  },
  computed: {
    // 按日期分组消息
    groupedMessages() {
      const groups = {};
      this.messages.forEach((message) => {
        const date = new Date(message.timestamp).toDateString();
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(message);
      });
      return groups;
    },
  },
  methods: {
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return `${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;
    },
    formatDate(dateString) {
      const today = new Date().toDateString();
      const yesterday = new Date(Date.now() - 86400000).toDateString();
      const date = new Date(dateString);

      if (dateString === today) return "今天";
      if (dateString === yesterday) return "昨天";

      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
  },
  mounted() {
    // 初始滚动到底部
    this.$nextTick(() => {
      const container = this.$refs.messagesContainer;
      container.scrollTop = container.scrollHeight;
    });
  },
};
</script>

<style scoped>
.chat-history-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  overflow-y: auto;
}

.chat-messages {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background: #fff;
}

.message-group {
  margin-bottom: 24px;
}

.date-divider {
  position: relative;
  margin: 16px 0;
  text-align: center;
  color: #909399;
  font-size: 12px;
}

.date-divider::before,
.date-divider::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 30%;
  height: 1px;
  background-color: #ebeef5;
}

.date-divider::before {
  left: 0;
}

.date-divider::after {
  right: 0;
}

.message {
  display: flex;
  margin-bottom: 16px;
}

.message-sent {
  justify-content: flex-end;
}

.message-received {
  justify-content: flex-start;
}

.avatar {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.message-content {
  /* max-width: 50%; */
}

.sender-name {
  font-size: 12px;
  color: #333333;
  margin-bottom: 4px;
}

.message-bubble {
  padding: 10px 14px;
  border-radius: 6px;
  position: relative;
  word-break: break-word;
}

.message-sent .message-bubble {
  background: #f5f7fa;
  color: #333333;
  border-top-right-radius: 0;
}

.message-received .message-bubble {
  background: #f5f7fa;
}
.message-time {
  font-size: 12px;
  color: #909399;
}

.message-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: 4px;
  cursor: pointer;
}

.message-file {
  display: flex;
  align-items: center;
  padding: 8px;
  background: #f5f7fa;
  border-radius: 4px;
}

.message-file .el-icon {
  margin-right: 8px;
  font-size: 20px;
}

.message-file span {
  flex: 1;
  margin: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
